import React from 'react';

import ErrorBoundary from '@/components/ErrorBoundary';
import { TripsIndex } from '@/components/route/trips/TripsIndex';

const TripsPage = () => (
  <ErrorBoundary>
    <TripsIndex />
  </ErrorBoundary>
);

export default TripsPage;
